import React from "react";
import { filterSales } from "../../../../../api/sales";
import { showSnackBar } from "../../../../../utils"
import { Dropdown } from "react-bootstrap"
import { toast } from "react-toastify"

export default props => {
    const [loading, setLoading] = React.useState(false)

    function download() {
        let request = filterSales
        if (props.request) {
            request = props.request
        }

        let { params } = props
        if (!params) {
            params = {}
        }
        // não exporte com paginação e remova "todos/todas"
        const clean = { ...params }
        delete clean.end_count
        if (clean.status === "todos") delete clean.status
        if (Array.isArray(clean.status) && clean.status.includes("todos")) delete clean.status
        if (clean.natureza === "todas") delete clean.natureza
        clean.report = "excel"
        setLoading(true)
        request(clean)
            .then(response => {
                const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${response.file}`;
                const downloadLink = document.createElement("a");
                downloadLink.href = linkSource;
                downloadLink.download = response.filename;
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
                setTimeout(() => {
                    toast.success("Relatório exportado!", { position: "top-center" })
                    window.scrollTo({ top: 0, behavior: "smooth" })
                    setLoading(false)
                }, 500)
            })
            .catch(error => {
                setLoading(false)
            })
    }

    return <Dropdown>
        <Dropdown.Toggle disabled={loading} variant="success" id="dropdown-export-report">
            {props.icon ? <i className="fas fa-download" /> : "Exportar Relatório"}
        </Dropdown.Toggle>

        <Dropdown.Menu>
            <Dropdown.Item onClick={download} href="#/action-1">Excel</Dropdown.Item>
            <Dropdown.Item disabled href="#/action-2">PDF</Dropdown.Item>
        </Dropdown.Menu>
    </Dropdown>
}


// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/List/DownloadReport/index.jsx